import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const InputDataQualityContext = createContext()

export const InputDataQualityProvider = ({ children }) => {
  const [rows, setRows] = useState([])
  const [dataMessage, setDataMessage] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingFilters, setLoadingFilters] = useState(true)
  const [filterOptions, setFilterOptions] = useState(null)
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [inputValue, setInputValue] = useState('')

  const onSelectFilter = value => {
    setSelectedUser(null)
    setInputValue('')
    setSelectedFilterOptions(value)
  }

  const onSelectUser = value => {
    setSelectedUser(value)
    setInputValue(value.name)
    setSelectedFilterOptions([])
  }

  const fetchData = async () => {
    if (!loading) setLoading(true)

    try {
      const { data } = await RequestService.getInputDataQuality({
        selectedFilterOptions,
        selectedUserId: selectedUser?.id,
      })
      setRows(data?.data || [])
      setDataMessage(data?.dataMessage || [])
    } catch (error) {
      console.error('Error on data fetch', error)
    }

    setLoading(false)
  }

  const getPossibleFilters = async () => {
    if (!loadingFilters) setLoadingFilters(true)

    try {
      const { data } = await RequestService.getInputDataQualityFilters()
      setFilterOptions(data)
    } catch (error) {
      console.error('Error on data fetch filters', error)
    }

    setLoadingFilters(false)
  }

  useEffect(() => {
    fetchData()
  }, [selectedFilterOptions, selectedUser?.id])

  useEffect(() => {
    getPossibleFilters()
  }, [])

  return (
    <InputDataQualityContext.Provider
      value={{
        rows,
        dataMessage,
        loading,
        loadingFilters,
        filterOptions,
        onSelectFilter,
        selectedFilterOptions,
        selectedUser,
        onSelectUser,
        inputValue,
        onInputValueChange: setInputValue,
      }}
    >
      {children}
    </InputDataQualityContext.Provider>
  )
}

export const useInputDataQuality = () => {
  return useContext(InputDataQualityContext)
}
